import React from 'react';
import Feature from './components/Feature.js';

export default class Featured extends React.Component{


    render(){

        return(
            <div id="featureWrapper" style={styles.wrapper}>
                <p style={styles.header}>Get the Best Quality for the Best Price</p>
                <div id="features" style={styles.features}>
                <Feature type={'brakes'}></Feature>
                <Feature type={'tires'}></Feature>
                <Feature type={'oil'}></Feature>
                </div>
            </div>
        )
    }
}

const styles = {
    wrapper: {marginTop: '495px', width: '100%', height: '400px', paddingTop: '20px'},
    header: {color: 'white', fontSize: '4vh'},
    features: {display: 'flex'}
}